import React from 'react';
import { useHistory } from 'react-router-dom';
import styles from './ErrorPage.module.scss';

const ErrorPage: React.FC = () => {
  const history = useHistory();

  function reload() {
    history.go(0);
  }

  return (
    <div className={styles.wrap}>
      <h1 className={styles.title}>エラー</h1>
      <p className={styles.description}>データの読み込みに失敗しました。</p>
      <button className={styles.button} type='button' onClick={reload}>
        再読み込み
      </button>
    </div>
  );
};

export default ErrorPage;
